<template>
  <div>
    <p class="container" style="text-align: center">
      Bienvenido al portal de la CVC donde podrás registrar tus solicitudes
      sobre el trámite de su interés
    </p>
    <p class="container" style="font-weight: bold; text-align: center">
      DERECHOS AMBIENTALES
    </p>
    <div class="container" id="DA">
      <!-- Inicio Acordeon -->
      <div class="accordion" role="tablist">
        <!-- CONCESIÓN DE AGUAS SUPERFICIALES -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-1
              variant="info"
              style="background: #45b39d"
              >CONCESIÓN DE AGUAS SUPERFICIALES</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Concesión de Aguas Superficiales.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Derecho que adquiere una persona natural o jurídica,
                        pública o privada, para aprovechar las aguas en un uso o
                        fin determinado. Se otorga mediante acto administrativo
                        que define el caudal de aprovechamiento y el régimen de
                        operación.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlSuperficiales()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional y
                        Formulario PUEAA.
                        <br />
                        <b-dropdown
                          variant="outline-primary"
                          text="Formularios"
                        >
                          <b-dropdown-item
                            @click="
                              abrirNuevoTab(rutas.rutaformatoSuperficiales)
                            "
                            ><b-icon
                              icon="paperclip"
                              aria-hidden="true"
                            ></b-icon>
                            FUN</b-dropdown-item
                          >
                          <b-dropdown-item
                            @click="abrirNuevoTab(rutas.rutapueaacomun)"
                            ><b-icon
                              icon="paperclip"
                              aria-hidden="true"
                            ></b-icon>
                            PUEAA Común</b-dropdown-item
                          >
                          <b-dropdown-item
                            @click="abrirNuevoTab(rutas.rutapueaasimplificado)"
                            ><b-icon
                              icon="paperclip"
                              aria-hidden="true"
                            ></b-icon>
                            PUEAA Simplificado</b-dropdown-item
                          > <b-dropdown-item
                            @click="abrirNuevoTab(rutas.rutacircularpueaa)"
                            ><b-icon
                              icon="paperclip"
                              aria-hidden="true"
                            ></b-icon>
                            Circular 06 PUEAA</b-dropdown-item
                          > <b-dropdown-item
                            @click="abrirNuevoTab(rutas.rutaorientacionpueaa)"
                            ><b-icon
                              icon="paperclip"
                              aria-hidden="true"
                            ></b-icon>
                            Orientaciones PUEAA</b-dropdown-item
                          > </b-dropdown
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaAnexoSuperficales)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- CONCESIÓN DE AGUAS SUBTERRÁNEAS -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-2
              variant="info"
              style="background: #45b39d"
              >CONCESIÓN DE AGUAS SUBTERRÁNEAS</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Otros (12)_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el modo de adquirir el derecho a usar o aprovechar
                        las aguas subterráneas, tanto en predios propios como
                        ajenos.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlSubterraneas()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional y
                        Formulario PUEAA.
                        <br />
                        <b-dropdown
                          variant="outline-primary"
                          text="Formularios"
                        >
                          <b-dropdown-item
                            @click="
                              abrirNuevoTab(rutas.rutaformatoSubterraneas)
                            "
                            ><b-icon
                              icon="paperclip"
                              aria-hidden="true"
                            ></b-icon>
                            FUN</b-dropdown-item
                          >
                          <b-dropdown-item
                            @click="abrirNuevoTab(rutas.rutapueaacomun)"
                            ><b-icon
                              icon="paperclip"
                              aria-hidden="true"
                            ></b-icon>
                            PUEAA Común</b-dropdown-item
                          >
                          <b-dropdown-item
                            @click="abrirNuevoTab(rutas.rutapueaasimplificado)"
                            ><b-icon
                              icon="paperclip"
                              aria-hidden="true"
                            ></b-icon>
                            PUEAA Simplificado</b-dropdown-item
                          > <b-dropdown-item
                            @click="abrirNuevoTab(rutas.rutacircularpueaa)"
                            ><b-icon
                              icon="paperclip"
                              aria-hidden="true"
                            ></b-icon>
                            Circular 06 PUEAA</b-dropdown-item
                          > <b-dropdown-item
                            @click="abrirNuevoTab(rutas.rutaorientacionpueaa)"
                            ><b-icon
                              icon="paperclip"
                              aria-hidden="true"
                            ></b-icon>
                            Orientaciones PUEAA</b-dropdown-item
                          ></b-dropdown
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaAnexoSubterraneas)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- PERMISO DE VERTIMIENTO A CUERPOS DE AGUA -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-3
              variant="info"
              style="background: #45b39d"
              >PERMISO DE VERTIMIENTO A CUERPOS DE AGUA</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Vertimientos_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        El permiso de vertimiento es el que concede la CVC,
                        mediante acto administrativo, a toda persona natural o
                        jurídica cuya actividad o servicio genere vertimientos a
                        las aguas superficiales, marinas, o al suelo.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlvertimiento_agua()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="
                            abrirNuevoTab(rutas.rutaformatoVertimientoagua)
                          "
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaAnexoVertimientoagua)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- PERMISO DE VERTIMIENTO AL SUELO -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-4
              variant="info"
              style="background: #45b39d"
              >PERMISO DE VERTIMIENTO AL SUELO</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Vertimientos_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        El permiso de vertimiento es el que concede la CVC,
                        mediante acto administrativo, a toda persona natural o
                        jurídica cuya actividad o servicio genere vertimientos a
                        las aguas superficiales, marinas, o al suelo.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlvertimiento_suelo()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="
                            abrirNuevoTab(rutas.rutaformatoVertimientosuelo)
                          "
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="
                            abrirNuevoTab(rutas.rutaAnexoVertimientosuelo)
                          "
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- ADECUACIÓN DE TERRENOS PARA ESTABLECIMIENTOS DE CULTIVOS, PASTOS Y BOSQUES -->
        <!-- <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-5
              variant="info"
              style="background: #45b39d"
              >ADECUACIÓN DE TERRENOS PARA ESTABLECIMIENTOS DE CULTIVOS, PASTOS
              Y BOSQUES</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Otros (2)_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el permiso que otorga la CVC, a quien pretenda
                        realizar actividades de adecuación de terrenos con el
                        objeto de establecer cultivos, pastos o bosques, y sea
                        necesario erradicar vegetación arbórea incluyendo
                        rastrojos altos, en diferentes estados de desarrollo.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          href="/AdecuacionTerreno"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formato.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="
                            abrirNuevoTab(rutas.rutaformatoAdecuacionterrenos)
                          "
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Formato </b-button
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>-->
        <!-- APROVECHAMIENTO FORESTAL PERSISTENTE -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-6
              variant="info"
              style="background: #45b39d"
              >APROVECHAMIENTO FORESTAL PERSISTENTE</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Aprovechamiento Forestal.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el permiso o autorización que otorga la CVC,
                        concediendo el derecho a aprovechar bosques naturales
                        ubicados en terrenos de dominio público o privado,
                        respectivamente.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                        @click="urlAprovechamientofp()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formato.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutafunforestal)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Formato </b-button
                        ><br />
                        <!--Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>-->
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- APROVECHAMIENTO FORESTAL UNICO -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-7
              variant="info"
              style="background: #45b39d"
              >APROVECHAMIENTO FORESTAL ÚNICO</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Aprovechamiento Forestal.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el permiso o autorización que otorga la CVC,
                        concediendo el derecho a aprovechar bosques naturales
                        ubicados en terrenos de dominio público o privado,
                        respectivamente.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlAprovechamientofu()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formato.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutafunforestal)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Formato </b-button
                        ><br />
                        <!--Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>-->
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- AUTORIZACION PARA OCUPACION DE CAUCE Y OBRAS HIDRAULICAS -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-8
              variant="info"
              style="background: #45b39d"
              >AUTORIZACIÓN PARA OCUPACIÓN DE CAUCE Y OBRAS
              HIDRÁULICAS</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Ocupación de Cauce_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es la construcción de obras que ocupen el cauce de una
                        corriente o depósito de agua, así como para la ocupación
                        permanente o transitoria de playas, así como la
                        aprobación de los diseños de las obras necesarias para
                        captar, controlar, conducir, almacenar o distribuir el
                        caudal de una corriente hídrica.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlAutorizacionocoh()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="
                            abrirNuevoTab(rutas.rutaformatoOcupacioncause)
                          "
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        <!--Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>-->
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- AUTORIZACION PARA VIAS CARRETEABLES Y EXPLANACIONES-->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-9
              variant="info"
              style="background: #45b39d"
              >AUTORIZACIÓN PARA VÍAS CARRETEABLES Y EXPLANACIONES</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Vías Carreteables y Explanaciones_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es la autorización que otorga la CVC, para la
                        construcción de vías, carreteables y explanaciones en
                        predios de propiedad privada en el área rural.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlAutorizacionvce()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formato.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="
                            abrirNuevoTab(rutas.rutaformatoViascarreteables)
                          "
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Formato </b-button
                        ><br />
                        <!--Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>-->
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- DIAGNOSTICO AMBIENTAL DE ALTERNATIVAS -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-10
              variant="info"
              style="background: #45b39d"
              >DIAGNOSTICO AMBIENTAL DE ALTERNATIVAS</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-10"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Otros (3)_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Trámite para evaluar y comparar las diferentes opciones
                        que presente el peticionario, bajo las cuales es posible
                        desarrollar un proyecto, obra o actividad.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlDiagnosticoAmbAlt()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <!--<b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>-->
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- EXPEDICIÓN DE CERTIFICADO DE EXPORTACIÓN DE ESPECIES DE FLORA NO CITES 
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-11
              variant="info"
              style="background: #45b39d"
              >EXPEDICIÓN DE CERTIFICADO DE EXPORTACIÓN DE ESPECIES DE FLORA NO
              CITES</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-11"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Otros (4)_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es la certificación que se otorga para la exportación de
                        productos forestales en segundo grado de transformación
                        o flor cortada, follaje y demás productos de la flora
                        silvestre no obtenidos mediante aprovechamiento del
                        medio natural No Cites.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          href="/Expedicionceefc"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>-->
        <!-- MODIFICACIÓN DE LICENCIA AMBIENTAL O PLAN DE MANEJO AMBIENTAL -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-12
              variant="info"
              style="background: #45b39d"
              >MODIFICACIÓN DE LICENCIA AMBIENTAL O PLAN DE MANEJO
              AMBIENTAL</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-12"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Licencimiento Ambiental_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Trámite para determinar la viabilidad ambiental de las
                        modificaciones a un proyecto, obra o actividad a la cual
                        se otorgó Licencia Ambiental o se estableció un Plan de
                        Manejo Ambiental.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlModificacionlapma()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <!--<b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>-->
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- OTORGAMIENTO DE LICENCIA AMBIENTAL -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-13
              variant="info"
              style="background: #45b39d"
              >OTORGAMIENTO DE LICENCIA AMBIENTAL</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-13"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Licencimiento Ambiental_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es la autorización para la ejecución de un proyecto,
                        obra o actividad que, de acuerdo con la ley y los
                        reglamentos, pueda producir deterioro grave a los
                        recursos naturales renovables o al medio ambiente o
                        introducir modificaciones considerables o notorias al
                        paisaje.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlOtorgamientola()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaOtorgamiento)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        <!--Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>-->
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- OTORGAMIENTO DE LICENCIA DE FUNCIONAMIENTO PARA ZOOLOGICOS Y PABELLONES DE FLORA SILVESTRE -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-14
              variant="info"
              style="background: #45b39d"
              >OTORGAMIENTO DE LICENCIA DE FUNCIONAMIENTO PARA ZOOLÓGICOS Y
              PABELLONES DE FLORA SILVESTRE</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-14"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Establecimiento Zoológicos_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Propiedad pública o privada, en donde se mantienen
                        individuos de fauna silvestre en confinamiento o
                        semiconfinamiento para exhibición y con propósitos
                        educativos y en el cual se adelantan investigaciones
                        biológicas sobre las especies en cautividad.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlOtorgamientolzoo()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <!--<b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>-->
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- OTORGAMIENTO DE PERMISO DE EMISIONES ATMOSFÉRICAS PARA FUENTES FIJAS -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-15
              variant="info"
              style="background: #45b39d"
              >OTORGAMIENTO DE PERMISO DE EMISIONES ATMOSFÉRICAS PARA FUENTES
              FIJAS</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-15"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Emisiones Atmosféricas_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        El permiso de emisión atmosférica es el que concede la
                        CVC, mediante acto administrativo, para que una persona
                        natural o jurídica, pública o privada propietaria de la
                        obra, empresa, actividad, industria o establecimiento
                        que origina las emisiones, pueda realizar emisiones al
                        aire.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlOtorgamientopeaff()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="
                            abrirNuevoTab(rutas.rutaformatoemisionesafmos)
                          "
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        <!--Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>-->
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- PERMISO O AUTORIZACIÓN PARA EL APROVECHAMIENTO DE PDTOS DE FLORA Y EJEMPLARES O PDTOS DE FAUNA SILVESTRE -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-16
              variant="info"
              style="background: #45b39d"
              >PERMISO O AUTORIZACIÓN PARA EL APROVECHAMIENTO DE PDTOS DE FLORA
              Y EJEMPLARES O PDTOS DE FAUNA SILVESTRE</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-16"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Registro de Establecimientos Explotación Fauna y Flora_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el permiso o autorización para el aprovechamiento de
                        productos de la flora y de ejemplares o productos de la
                        fauna silvestre.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button  
                        @click="urlPermisoaffs()"
                        variant="outline-success">
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formato.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutafunforestal)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Formato </b-button
                        ><br />
                        <!--Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>-->
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- PERMISO PARA EL APROVECHAMIENTO FORESTAL DOMESTICO -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-17
              variant="info"
              style="background: #45b39d"
              >PERMISO PARA EL APROVECHAMIENTO FORESTAL DOMESTICO</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-17"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Otros (5)_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el permiso o autorización que otorga la CVC,
                        concediendo el derecho a aprovechar bosques naturales
                        ubicados en terrenos de dominio público o privado,
                        respectivamente.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button @click="urlPermisoafd()" variant="outline-success">
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formato.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutafunforestal)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Formato </b-button
                        ><br />
                        <!--Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>-->
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- PERMISO PARA EL FUNCIONAMIENTO DE JARDINES BOTANICOS -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-18
              variant="info"
              style="background: #45b39d"
              >PERMISO PARA EL FUNCIONAMIENTO DE JARDINES BOTÁNICOS</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-18"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Jardines Botánicos_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Las colecciones de plantas vivas científicamente
                        organizadas, para tener los beneficios, estímulos y
                        prerrogativas contemplados en la Ley 299 de julio 26 de
                        1996, "Por la cual se protege la flora colombiana, se
                        reglamentan los jardines botánicos y se dictan otras
                        disposiciones".
                      </b-card-text>
                      <center>
                        <br />
                        <b-button @click="urlPermisofjb()" variant="outline-success">
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <!--<b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>-->
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- APROVECHAMIENTO PRIORITARIO DE GUADUALES O BAMBUSALES NATURALEZ-->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-42
              variant="info"
              style="background: #45b39d"
              >APROVECHAMIENTO PRIORITARIO DE GUADUALES O BAMBUSALES NATURALES</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-42"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Registro de Establecimientos Explotación Fauna y Flora_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es la autorización o permiso para aprovechar de manera inmediata un guadual o bambusal afectado por un vendaval, problemas fitosanitarios u otras causas naturales.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button @click="urlFormularioAproGuaduales()" variant="outline-success">
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <!--<b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>-->
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- PERMISO RECOLECCIÓN ESPECÍMENES SILVESTRES DE DIVERSIDAD BIOLÓGICA FINES DE ELABORACIÓN ESTUDIOS AMB -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-19
              variant="info"
              style="background: #45b39d"
              >PERMISO RECOLECCIÓN ESPECÍMENES SILVESTRES DE DIVERSIDAD
              BIOLÓGICA FINES DE ELABORACIÓN ESTUDIOS AMB</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-19"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Otros (6)_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el permiso para la recolección de especímenes de
                        especies de la diversidad biológica con fines de
                        investigación científica no comercial o con fines de
                        elaboración de estudios ambientales.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlPermisoresdbee()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <!--<b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>-->
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        
        <!-- PERMISO DE APROVECHAMIENTO DE ÁRBOLES AISLADOS-->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-24
              variant="info"
              style="background: #45b39d"
              >PERMISO DE APROVECHAMIENTO DE ÁRBOLES AISLADOS</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-24"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Otros (10)_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el permiso o autorización de aprovechamiento de
                        árboles aislados.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlSinriesgoapteaa()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formato.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutafunforestal)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Formato </b-button
                        ><br />
                        <!--Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>-->
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
    <br />

    <p class="container" style="font-weight: bold; text-align: center">
      SOLICITUDES PRIORITARIAS - TALA DE EMERGENCIA - TALA O REUBICACIÓN POR
      OBRA PÚBLICA O PRIVADA DE ÁRBOLES AISLADOS
    </p>
    <div class="container">
      <!-- Inicio Acordeon -->
      <div class="accordion" role="tablist">
        <!-- SOLICITUDES PRIORITARIAS DE ÁRBOLES AISLADOS -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-20
              variant="info"
              style="background: #45b39d"
              >SOLICITUDES PRIORITARIAS DE ÁRBOLES AISLADOS</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-20"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Emisiones Atmosféricas_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es la autorización o permiso para aprovechar árboles
                        aislados de bosque natural que se encuentren caídos o
                        muertos por causas naturales, o que por razones de orden
                        sanitario requieran ser talados o ubicado en terrenos
                        públicos o privados.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlPorriesgoapteaa()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formato.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutafunforestal)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Formato </b-button
                        ><br />
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- TALA DE EMERGENCIA -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-46
              variant="info"
              style="background: #45b39d"
              >TALA DE EMERGENCIA</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-46"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Emisiones Atmosféricas_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el permiso o autorización para talar o podar árboles
                        aislados en centros urbanos que, por razones de su
                        ubicación, estado sanitario o daños mecánicos, estén
                        causando perjuicio a la estabilidad de los suelos,
                        canales de agua, andenes, calles, obras de
                        infraestructura o edificaciones.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlPorriesgoapteaa()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formato.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutafunforestal)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Formato </b-button
                        ><br />
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- TALA O REUBICACIÓN POR OBRA PÚBLICA O PRIVADA -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-47
              variant="info"
              style="background: #45b39d"
              >TALA O REUBICACIÓN POR OBRA PÚBLICA O PRIVADA</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-47"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Emisiones Atmosféricas_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el permiso o autorización para talar, transplantar o
                        reubicar árboles aislados en centros urbanos, para la
                        realización, remodelación o ampliación de obras públicas
                        o privadas de infraestructura, construcciones,
                        instalaciones y similares.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlFormularioTalarpp()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formato.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutafunforestal)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Formato </b-button
                        ><br />
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
    <br />

    <p class="container" style="font-weight: bold; text-align: center">
      OTROS TRÁMITES AMBIENTALES
    </p>
    <div class="container" id="OTA">
      <!-- Inicio Acordeon -->
      <div class="accordion" role="tablist">
        <!-- CESIÓN  DE DERECHOS AMBIENTALES -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-25
              variant="info"
              style="background: #3498db"
              >CESIÓN DE DERECHOS AMBIENTALES</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-25"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Registro de Establecimientos Explotación Fauna y Flora_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es la autorización de la cesión de un derecho ambiental
                        otorgado previamente por la Corporación.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urlCesiondr()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- CONSTITUCIÓN PARTE INTERESADA -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-26
              variant="info"
              style="background: #3498db"
              >CONSTITUCIÓN PARTE INTERESADA</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-26"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Concesión de Aguas Superficiales.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el reconocimiento de la CVC de una persona natural o
                        jurídica, pública o privada, para que ejerza su derecho
                        a participar en la toma de decisiones en materia
                        ambiental.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urldatosConstitucionpi()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- CONSULTA PREVIA -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-27
              variant="info"
              style="background: #3498db"
              >CONSULTA PREVIA</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-27"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Otros (10)_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Derecho fundamental que tienen los grupos étnicos, de
                        poder decidir sobre medidas legislativas y
                        administrativas o proyectos, obras que se vayan a
                        realizar dentro de sus territorios, buscando de esta
                        manera proteger su integridad cultural, social y
                        económica y garantizar su participación.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urldatosConsultap()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- ACREDITACIÓN O CERTIFICACIÓN DE LAS INVERSIONES DE CONTROL Y MEJORAMIENTO DEL MEDIO AMBIENTE -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-28
              variant="info"
              style="background: #3498db"
              >ACREDITACIÓN O CERTIFICACIÓN DE LAS INVERSIONES DE CONTROL Y
              MEJORAMIENTO DEL MEDIO AMBIENTE</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-28"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Registro de Establecimientos Explotación Fauna y Flora_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urldatosAcreditacioncicmma()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- ACTIVACIÓN DE INSCRIPCIÓN EN EL INVENTARIO NACIONAL DE PCB 
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-29
              variant="info"
              style="background: #3498db"
              >ACTIVACIÓN DE INSCRIPCIÓN EN EL INVENTARIO NACIONAL DE
              PCB</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-29"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Concesión de Aguas Superficiales.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urldatosActivacionpcb()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>-->
        <!-- DESINTEGRACIÓN VEHICULAR -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-30
              variant="info"
              style="background: #3498db"
              >DESINTEGRACIÓN VEHICULAR</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-30"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Otros (10)_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Certificación ambiental a entidades desintegradoras en
                        cumplimiento con las condiciones y requisitos
                        ambientales que permiten desarrollar el proceso de
                        desintegración de vehículos automotores.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urldatosdesintegracionv()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- EXPEDICIÓN CONCEPTOS TÉCNICOS RELACIONADOS CON AGUAS SUBTERRÁNEAS -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-31
              variant="info"
              style="background: #3498db"
              >EXPEDICIÓN CONCEPTOS TÉCNICOS RELACIONADOS CON AGUAS
              SUBTERRÁNEAS</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-31"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Registro de Establecimientos Explotación Fauna y Flora_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es la emisión de un concepto técnico relacionado con las
                        aguas subterráneas.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urldatosExpedicionctras()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- EXPEDICIÓN DE LA CERTIFICACIÓN DE EQUIPOS EN MATERIA DE REVISIÓN DE GASES PARA CENTROS DE DIAGNÓSTICO AUTOMOTOR -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-32
              variant="info"
              style="background: #3498db"
              >EXPEDICIÓN DE LA CERTIFICACIÓN DE EQUIPOS EN MATERIA DE REVISIÓN
              DE GASES PARA CENTROS DE DIAGNÓSTICO AUTOMOTOR</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-32"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Concesión de Aguas Superficiales.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urldatosExpedicioncemrgcda()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <!--<b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>-->
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- PLANES DE CONTINGENCIA PARA MANEJO DE DERRAMES DE HIDROCARBUROS O SUSTANCIAS NOCIVAS -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-36
              variant="info"
              style="background: #3498db"
              >PLANES DE CONTINGENCIA PARA MANEJO DE DERRAMES DE HIDROCARBUROS O
              SUSTANCIAS NOCIVAS</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-36"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Otros (10)_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urldatosPlanescmdhsn()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- PLAN DE CONTINGENCIA PARA EL TRANSPORTE DE HIDROCARBUROS, DERIVADOS O SUSTANCIAS NOCIVAS Y RADICACION DEL REPORTE ANUAL DE ESTE PLAN -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-51
              variant="info"
              style="background: #3498db"
              >PLAN DE CONTINGENCIA PARA EL TRANSPORTE DE HIDROCARBUROS, DERIVADOS O SUSTANCIAS NOCIVAS Y RADICACION DEL REPORTE ANUAL DE ESTE PLAN</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-51"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/pct.png"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Toda persona natural o jurídica que realiza actividades de transporte de hidrocarburos, derivados y sustancias nocivas no sujetas a licenciamiento ambiental, debe radicar el plan de contingencias para el manejo de derrames en el desarrollo de dicha actividad.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                        href="/FormularioPlanchsn"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formato de la solicitud.
                        <br />
                        <b-dropdown
                          variant="outline-primary"
                          text="Formato"
                        >
                          <b-dropdown-item
                            @click="
                              abrirNuevoTab(rutas.rutaFormatoPlanContingenciaTranspote)
                            "
                            ><b-icon
                              icon="paperclip"
                              aria-hidden="true"
                            ></b-icon>
                            Formato Adjunto</b-dropdown-item
                          ></b-dropdown
                        >
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- PLANES DE SANEAMIENTO Y MANEJO DE VERTIMIENTOS - PSMV -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-37
              variant="info"
              style="background: #3498db"
              >PLANES DE SANEAMIENTO Y MANEJO DE VERTIMIENTOS - PSMV</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-37"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Registro de Establecimientos Explotación Fauna y Flora_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Trámite para recibir aprobación de los Planes de
                        Saneamiento y Manejo de Vertimientos – PMSV presentados
                        por los prestadores del servicio de alcantarillado y
                        actividades complementarias, de acuerdo a la
                        normatividad vigente.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urldatosPlanessmv()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- PROGRAMA PARA EL USO EFICIENTE Y AHORRO DEL AGUA - PUEAA -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-38
              variant="info"
              style="background: #3498db"
              >PROGRAMA PARA EL USO EFICIENTE Y AHORRO DEL AGUA -
              PUEAA</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-38"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Concesión de Aguas Superficiales.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Herramienta de planificación y administración enfocada a
                        la optimización del uso del recurso hídrico, conformado
                        por el conjunto de proyectos y acciones que le
                        corresponde adoptar a los usuarios que soliciten
                        concesión de aguas, con el propósito de contribuir a la
                        sostenibilidad.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urldatosProgramaueha()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- PLAN DE CUMPLIMIENTO -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-39
              variant="info"
              style="background: #3498db"
              >PLAN DE CUMPLIMIENTO</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-39"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Otros (10)_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el instrumento mediante el cual el interesado
                        presenta a la CVC, los proyectos, obras, actividades y
                        buenas prácticas, que garanticen el cumplimiento de la
                        norma de vertimientos y que incluye las metas, sus
                        periodos de evaluación y sus indicadores de seguimiento,
                        gestión y resultados.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          v-on:click="urldatosPlanCumplimiento()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- RAMA JUDICIAL -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-40
              variant="info"
              style="background: #3498db"
              >RAMA JUDICIAL NOTIFICACIONES</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-40"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Registro de Establecimientos Explotación Fauna y Flora_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el trámite que adelanta un despacho judicial para dar
                        a conocer a la CVC de una actuación procesal.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urldatosRamajn()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- TRASPASO, AUMENTO, REBAJA, CANCELACION, UNIFICACIÓN CAMBIO DE USO O CAMBIO DE SITIO DE CAPTACIÓN-->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-41
              variant="info"
              style="background: #3498db"
              >TRASPASO, AUMENTO, REBAJA, CANCELACIÓN, UNIFICACIÓN CAMBIO DE USO
              O CAMBIO DE SITIO DE CAPTACIÓN</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-41"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Concesión de Aguas Superficiales.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        El traspaso total o parcial de una concesión de aguas,
                        corresponde a la cesión del derecho ambiental en los
                        eventos que se produzca la tradición del predio
                        beneficiario con una concesión.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          @click="urldatostrasaumrebcanuni()"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- REGISTRO DE ESTABLECIMIENTOS DEDICADOS A LA EXPLOTACIÓN DE RECURSOS DE FLORA Y FAUNA 
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-21
              variant="info"
              style="background: #3498db"
              >REGISTRO DE ESTABLECIMIENTOS DEDICADOS A LA EXPLOTACIÓN DE
              RECURSOS DE FLORA Y FAUNA</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-21"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Registro de Establecimientos Explotación Fauna y Flora_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el registro de las empresas dedicadas a la
                        transformación primaria, transformación secundaria,
                        comercialización y transformación secundaria y las
                        integradas de productos forestales, de los viveros
                        forestales, criaderos de flora silvestre, huertos o
                        rodales semilleros.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          href="/Regisrtroederff"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>-->
        <!-- REGISTRO DE PLANTACIONES PROTECTORAS, PROTECTORAS - PRODUCTORAS 
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-22
              variant="info"
              style="background: #3498db"
              >REGISTRO DE PLANTACIONES PROTECTORAS, PROTECTORAS -
              PRODUCTORAS</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-22"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Otros (9)_10x15.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el acto administrativo motivado por el cual se
                        procede a registrar las plantaciones forestales
                        protectoras, productoras y protectoras.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button href="/Regisrtropp" variant="outline-success">
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaFormatoPlantaciones)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>-->
        <!-- REGISTRO DEL LIBRO DE OPERACIONES DE INDUSTRIAS O EMPRESAS FORESTALES
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-23
              variant="info"
              style="background: #3498db"
              >REGISTRO DEL LIBRO DE OPERACIONES DE INDUSTRIAS O EMPRESAS
              FORESTALES</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-23"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Concesión de Aguas Superficiales.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Es el acto administrativo motivado por el cual se
                        procede a registrar el libro de operaciones de las
                        industrias o empresas forestales.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                          href="/Regisrtroloief"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                  <b-col md="4">
                    <b-card-body title="Información del trámite">
                      <b-card-text>
                        Consulte y/o Descargue el Formulario Único Nacional.
                        <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          FUN </b-button
                        ><br />
                        Consulte y/o Descargue información sobre anexos
                        necesarios. <br />
                        <b-button
                          style="width: 40%"
                          variant="outline-primary"
                          @click="abrirNuevoTab(rutas.rutaf1a)"
                        >
                          <b-icon icon="paperclip" aria-hidden="true"></b-icon>
                          Anexos
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>-->
        <!-- REGISTRO NEGOCIO VERDE
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle.accordion-48
              variant="info"
              style="background: #3498db"
              >REGISTRO NEGOCIO VERDE</b-button
            >
          </b-card-header>
          <b-collapse
            id="accordion-48"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card
                no-body
                class="overflow-hidden"
                style="background: #f5f5f5"
              >
                <b-row no-gutters>
                  <b-col md="4">
                    <b-card-img
                      src="../../../img/Concesión de Aguas Superficiales.jpg"
                      alt="Image"
                      class="rounded-0"
                    ></b-card-img>
                  </b-col>
                  <b-col md="8">
                    <b-card-body title="">
                      <b-card-text style="text-align: justify; height: 135px">
                        Los negocios verdes son las actividades económicas en
                        las que se ofertan bienes o servicios, que generan
                        impactos ambientales positivos y además incorporan
                        buenas prácticas ambientales, sociales y económicos con
                        enfoque de ciclo de vida.
                      </b-card-text>
                      <center>
                        <br />
                        <b-button
                        href="/FormularioNverde"
                          variant="outline-success"
                        >
                          <b-icon
                            icon="receipt-cutoff"
                            aria-hidden="true"
                          ></b-icon>
                          Diligencie aquí formulario en línea</b-button
                        >
                      </center>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>-->
      </div>
    </div>
    <br />
  </div>
</template>

<script>
import {
  datosCesiondr,
  datosConstitucionpi,
  datosConsultap,
  datosAcreditacioncicmma,
  datosActivacionpcb,
  datosdesintegracionv,
  datosExpedicionctras,
  datosExpedicioncemrgcda,
  datosInscripcionrurm,
  datosInscripciondgae,
  datosInscripcionrespel,
  datosPlanescmdhsn,
  datosPlanessmv,
  datosProgramaueha,
  datosPlanCumplimiento,
  datosRamajn,
  datostrasaumrebcanuni,
  PLAN_DE_CONTINGENCIA_PARA_EL_TRANSPORTE_DE_HIDROCARBUROS,
  CONCESION_DE_AGUAS_SUPERFICIALES,
  CONCESION_DE_AGUAS_SUBTERRANEAS,
  PERMISO_DE_VERTIMIENTOS,
    APROVECHAMIENTO_FORESTAL_PERSISTENTE,
    APROVECHAMIENTO_FORESTAL_UNICO,
    AUTO_OCUPACION_CAUSE_OBRAS_HIDRAULICAS,
    AUTO_VIAS_CARRETEABLES_EXPLANACIONES,
    DIAGNOSTICO_AMBIENTAL_ALTERNATIVAS,
    MODIFICACION_LICENCIA_AMBIENTAL,
    OTORGAMIENTO_LICENCIA_AMBIENTAL,
    LICENCIA_ZOOLOGICOS_FLORA_SILVESTRE,
    PERMISO_EMISIONES_ATMOSFERICAS_FUENTES_FIJAS,
    PERMISO_O_AUTORIZACION_PARA_EL_APROVECHAMIENTO_DE_PDTOS_DE_FLORA_Y_EJEMPLARES_O_PDTOS_DE_FAUNA_SILVESTRE,
    PERMISO_APROVECHAMIENTO_FORESTAL_DOMESTICO,
    PERMISO_JARDINES_BOTANICOS,
    PERMISO_ESPECIMENES_SILVESTRES_FINES_ESTUDIOS_AMB,
    PORRIESGOAPTEEAA,
    SINRIESGOAPTEEAA,
    FORMULARIO_TALARPP,
    APROVECHAMIENTO_PRIORITARIO_DE_GUADUALES_O_BAMBUSALES_NATURALEZ
} from "../properties";
export default {
  data() {
    return {
      show: true,
      selected: null,
      rutas: {
        rutaformatoSuperficiales:
          "../../document/FT.0350.17 FUN de solicitud de concesión de aguas superficiales V03.pdf",
        rutaAnexoSuperficales:
          "../../document/Anexos Concesiones de Aguas Superficiales.pdf",
        rutaformatoSubterraneas:
          "../../document/FT.0350.18 FUN de solicitud de concesión de aguas subterráneas V03.pdf",
        rutaAnexoSubterraneas:
          "../../document/Anexos Concesiones de Aguas Subterráneas.pdf",
        rutaformatoVertimientoagua:
          "../../document/FT.0350.51 FUN de permiso de vertimiento a cuerpos de agua V01.pdf",
        rutaAnexoVertimientoagua:
          "../../document/Anexos Vertimientos al Agua.pdf",
        rutaformatoVertimientosuelo:
          "../../document/02-11-2021-anla-funpvsuelo.pdf",
        rutaAnexoVertimientosuelo:
          "../../document/Anexos Vertimientos al Suelo.pdf",
        rutaformatoAdecuacionterrenos:
          "../../document/FT.0350.07 V02 20201221 Solicitud de autorizacion para adecuacionde terrenos.doc",
        rutaformatoViascarreteables:
          "../../document/FT.0350.08 V04 20240320 Solicitud apertura de vias, carreteables y explanaciones.doc",
        rutaformatoAprovechamietoforestal:
          "../../document/FT.0350.09 Formulario de solicitud de aprovechamiento forestal arboles aislados.doc",
        rutaformatoOcupacioncause:
          "../../document/FT.0350.21 FUN  solicitud de Ocupacion de Cauce, playas y lechos.pdf",
        rutaformatoemisionesafmos:
          "../../document/FT.0350.15 FUN  solicitud de permiso de emisiones atmosfericas fuentes fijas.doc",
        rutapueaasimplificado:
          "../../document/FT.0350.53 V02 20231227 Formulario para la presentacion del programa PUEAA Simplificado.xlsx",
        rutapueaacomun:
          "../../document/FT.0350.54 V02 20231227 Formulario para la presentacion del programa PUEAA Comun.xlsx",
        rutafunforestal: "../../document/fun forestal.pdf",
        rutaOtorgamiento:
          "../../document/anexo_1_formulario_unico_solicitud_o_modificacion_licencia_ambiental.xlsx",
        rutaReporteanual:
          "../../document/FT.0340.66 V01 20221130 Reporte anual  de aceite de cocina usado - ACU - Para gestores.xlsx",
        rutaFormatoIET: "../../document/ANEXO IV INS_TRNASFORMADORAS.pdf",
        rutaFormatoRua:
          "../../document/ANEXO 2 INSCRIPCIÓN RUA_Resolucion 1023 de 2010.pdf",
        rutaFormatoRespel:
          "../../document/Formato Solicitud Inscripcion Registro Respel.pdf",
        rutaFormatoDGA:
          "../../document/FT.0340.20 V03 20221012 Inscripcion o actualizacion del departamento de gestion ambiental.pdf",
        rutaFormatoPlantaciones:
          "../../document/FUN-Registro-plantaciones-forestales-protectoras-y-o-pro.pdf",
          rutacircularpueaa:
          "../../document/Circular No 0006 - Orientaciones frente a presentacion de PUEAA.pdf",
          rutaFormatoPlanContingenciaTranspote:"../../document/FormatoPlanContigenciaTransporteHidrocarburos.pdf",
          rutaorientacionpueaa:"../../document/102pueaa.pdf",
      },
    };
  },
  methods: {
    abrirNuevoTab(param) {
      // Abrir nuevo tab
      var url = param;
      var win = window.open(url, "_blank");
      // Cambiar el foco al nuevo tab (punto opcional)
      win.focus();
    },
    urlFormularioAproGuaduales() {
      this.$router.push({
        name: "Porriesgoapteaa",
        params:{ id: APROVECHAMIENTO_PRIORITARIO_DE_GUADUALES_O_BAMBUSALES_NATURALEZ }
      });
    }, 
    urlFormularioTalarpp() {
      this.$router.push({
        name: "Porriesgoapteaa",
        params:{ id: FORMULARIO_TALARPP }
      });
    }, 
    urlPorriesgoapteaa() {
      this.$router.push({
        name: "Porriesgoapteaa",
        params:{ id:  PORRIESGOAPTEEAA} //SOLICITUDES PRIORITARIAS DE ÁRBOLES AISLADOS -- TALA DE EMERGENCIA
      });
    }, 
    urlSinriesgoapteaa() {
      this.$router.push({
        name: "Porriesgoapteaa",
        params:{ id:  SINRIESGOAPTEEAA} //PERMISO DE APROVECHAMIENTO DE ÁRBOLES AISLADOS
      });
    }, 
    urlPermisoresdbee() {
      this.$router.push({
        name: "Permisoresdbee",
        params:{ id:  PERMISO_ESPECIMENES_SILVESTRES_FINES_ESTUDIOS_AMB}
      });
    }, 
    urlPermisofjb() {
      this.$router.push({
        name: "Permisofjb",
        params:{ id:  PERMISO_JARDINES_BOTANICOS}
      });
    }, 
    urlPermisoafd() {
      this.$router.push({
        name: "Porriesgoapteaa",
        params:{ id:  PERMISO_APROVECHAMIENTO_FORESTAL_DOMESTICO}
      });
    }, 
    urlPermisoaffs() {
      this.$router.push({
        name: "Porriesgoapteaa",
        params:{ id:  PERMISO_O_AUTORIZACION_PARA_EL_APROVECHAMIENTO_DE_PDTOS_DE_FLORA_Y_EJEMPLARES_O_PDTOS_DE_FAUNA_SILVESTRE}
      });
    }, 
    urlOtorgamientopeaff() {
      this.$router.push({
        name: "Otorgamientopeaff",
        params:{ id:  PERMISO_EMISIONES_ATMOSFERICAS_FUENTES_FIJAS}
      });
    }, 
    urlOtorgamientolzoo() {
      this.$router.push({
        name: "Otorgamientolzoo",
        params:{ id:  LICENCIA_ZOOLOGICOS_FLORA_SILVESTRE}
      });
    }, 
    urlOtorgamientola() {
      this.$router.push({
        name: "Otorgamientola",
        params:{ id:  OTORGAMIENTO_LICENCIA_AMBIENTAL}
      });
    }, 
    urlModificacionlapma() {
      this.$router.push({
        name: "Modificacionlapma",
        params:{ id:  MODIFICACION_LICENCIA_AMBIENTAL}
      });
    }, 
    urlDiagnosticoAmbAlt() {
      this.$router.push({
        name: "DiagnosticoAmbAlt",
        params:{ id:  DIAGNOSTICO_AMBIENTAL_ALTERNATIVAS}
      });
    }, 
    urlAutorizacionvce() {
      this.$router.push({
        name: "Autorizacionvce",
        params:{ id:  AUTO_VIAS_CARRETEABLES_EXPLANACIONES}
      });
    }, 
    urlAutorizacionocoh() {
      this.$router.push({
        name: "Autorizacionocoh",
        params:{ id:  AUTO_OCUPACION_CAUSE_OBRAS_HIDRAULICAS}
      });
    }, 
    urlAprovechamientofu() {
      this.$router.push({
        name: "Porriesgoapteaa",
        params:{ id:  APROVECHAMIENTO_FORESTAL_UNICO}
      });
    }, 
    urlAprovechamientofp() {
      this.$router.push({
        name: "Porriesgoapteaa",
        params:{ id:  APROVECHAMIENTO_FORESTAL_PERSISTENTE}
      });
    }, 
    urlvertimiento_suelo() {
      this.$router.push({
        name: "vertimiento_suelo",
        params:{ id:  PERMISO_DE_VERTIMIENTOS}
      });
    }, 
    urlvertimiento_agua() {
      this.$router.push({
        name: "vertimiento_agua",
        params:{ id:  PERMISO_DE_VERTIMIENTOS}
      });
    }, 
    urlSuperficiales() {
      this.$router.push({
        name: "Superficiales",
        params: {
          id: CONCESION_DE_AGUAS_SUPERFICIALES,
        }
      });
    },    
    urlSubterraneas() {
      this.$router.push({
        name: "Subterraneas",
        params: {
          id: CONCESION_DE_AGUAS_SUBTERRANEAS,
        },
      });
    },
    urlCesiondr() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosCesiondr,
      });
    },
    urldatosConstitucionpi() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosConstitucionpi,
      });
    },
    urldatosConsultap() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosConsultap,
      });
    },
    urldatosAcreditacioncicmma() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosAcreditacioncicmma,
      });
    },
    urldatosActivacionpcb() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosActivacionpcb,
      });
    },
    urldatosdesintegracionv() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosdesintegracionv,
      });
    },
    urldatosExpedicionctras() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosExpedicionctras,
      });
    },
    urldatosExpedicioncemrgcda() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosExpedicioncemrgcda,
      });
    },
    urldatosInscripcionrurm() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosInscripcionrurm,
      });
    },
    urldatosInscripciondgae() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosInscripciondgae,
      });
    },
    urldatosInscripcionrespel() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosInscripcionrespel,
      });
    },
    urldatosPlanescmdhsn() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosPlanescmdhsn,
      });
    },
    urldatosPlancth() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: PLAN_DE_CONTINGENCIA_PARA_EL_TRANSPORTE_DE_HIDROCARBUROS,
      });
    },
    urldatosPlanessmv() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosPlanessmv,
      });
    },
    urldatosProgramaueha() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosProgramaueha,
      });
    },
    urldatosPlanCumplimiento() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosPlanCumplimiento,
      });
    },
    urldatosRamajn() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datosRamajn,
      });
    },
    urldatostrasaumrebcanuni() {
      //console.log(datosCesiondr);
      this.$router.push({
        name: "Generico",
        params: datostrasaumrebcanuni,
      });
    },
  },
  components: {},
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #000000;
}
</style>
